module.exports = __webpack_public_path__ + "static/media/depai-chessbot.b8315128.jpg";